export default __webpack_public_path__ + "static/media/LOGO_LEYENDA.17cafcbb.png";